import React, { useState } from 'react';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom'; // Add this import
import PaymentApiService from '../../ApiServices/PaymentApiServices/PaymentApiService';
// import AppApiService from '../../ApiServices/PaymentApiService/AppApiService';
import { useAuth } from "../Auth/AuthContext";  

// Set custom styles for the modal
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        borderRadius: '8px',
        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
        backgroundColor: '#f9f9f9',
        width: '500px',
    },
};

const AddPaymentModalForm = ({ isOpen, closeModal, fetchData  }) => {
    const [formData, setFormData] = useState({
        Name: '',
        Url: '',
        Title: '',
        Description: '',
        AppWeb: 'Playstore',
        UserId: '',
        Address :'' 
    });

    const [loading, setLoading] = useState(false);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     toast.success("Your QA ticket has been created and is waiting for admin review!", { position: "top-center" });
    //     closeModal(); // Close the modal after submission
    // };
    const Auth = useAuth(); // Get user from AuthContext
    const user = Auth.authState.user;
   
    const handleSubmit = async (e) => {
        e.preventDefault();
      setLoading(true);
  
      // Validate passwords
      // if (password !== confirmPassword) {
      //     setLoading(false);
      //     return;
      // }
  
      const PaymentData = {
         
        BankAccountNumber: document.getElementById('BankAccountNumber').value,
        BankName: document.getElementById('BankName').value,
        BankBranch: document.getElementById('BankBranch').value,
        Owner: document.getElementById('Owner').value,
        SwiftCode: document.getElementById('SwiftCode').value,
        Address : document.getElementById('Address').value,
        UserId: user.id,
        IsActive: false,
      };
  
      try {
            
          const result = await PaymentApiService.Add(PaymentData); // Call API service
        //   webAppTable.fetchData();
          if (result.message == 'Payment limit reached'){
            toast.warning(result.message);             
          }   
          else{
            toast.success(result.message);
            fetchData(); // Fetch updated data
          }
          closeModal();
      } catch (error) {
          toast(error.message);
          console.error('Add Payment error:', error);
      } finally {
          setLoading(false);
      }
  };
    return (
        <>
            <ToastContainer />
            
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
            >
                <div className="p-6">
                    <h2 className="text-xl font-semibold text-center mb-4 text-gray-700">Add QA Ticket</h2>
                    <form onSubmit={handleSubmit} className="space-y-4">

                         

                        {/* {['Name', 'Url', 'Title', 'Description', 'UserId'].map((field) => ( */}
                        {['BankAccountNumber', 'BankName', 'BankBranch', 'Owner', 'SwiftCode','Address'].map((field) => (
                            <div key={field} className="flex flex-col">
                                <label htmlFor={field} className="text-gray-600 mb-1">
                                    {field}
                                </label>
                                <input
                                    type="text"
                                    id={field}
                                    name={field}
                                    value={formData[field]}
                                    onChange={handleInputChange}
                                    className="border border-gray-300 rounded-md p-2 focus:outline-none focus:border-blue-500"
                                    placeholder={`Enter ${field}`}
                                />
                            </div>
                        ))}

                        <div className="flex justify-end space-x-3 mt-6">
                            <button
                                type="submit"
                                className="px-4 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700 transition duration-200"
                            >
                                Add Payment Detail
                            </button>
                            <button
                                type="button"
                                onClick={closeModal}
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md shadow-md hover:bg-gray-400 transition duration-200"
                            >
                                Close
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    );
};

export default AddPaymentModalForm;
